import c from "classnames";
import { ComponentProps, ReactNode, useMemo } from "react";
import { NavLink } from "react-router";

import { Icon } from "@design-system/Icon/Icon";
import { Text } from "@design-system/Text/Text";

import classes from "./Tab.module.css";

type Props = {
  name: ReactNode;
  to?: string;
  end?: boolean;
  icon?: ComponentProps<typeof Icon>["icon"];
  isActive?: boolean;
  onClick?: () => void;
  bubbleCount?: number;
};

export const Tab = ({ name, to, end = false, icon, isActive: activeProp, onClick, bubbleCount }: Props) => {
  const bubbletext = useMemo(() => {
    if (bubbleCount && bubbleCount > 9) {
      return "9+";
    }
    return bubbleCount?.toString() || "";
  }, [bubbleCount]);

  const shouldShowBubble = bubbleCount !== undefined && bubbleCount > 0;

  const content = (
    <div className={classes.contentWrapper}>
      {icon && <Icon icon={icon} />}
      {typeof name === 'string' ? (
        <Text color="inherit" weight={500}>
          {name}
        </Text>
      ) : (
        name
      )}
      {shouldShowBubble ? (
        <div className={classes.bubbleContainer}>
          {bubbletext ? <span>{bubbletext}</span> : null}
        </div>
      ) : null}
    </div>
  );

  if (to) {
    return (
      <NavLink
        className={({ isActive }) => c(classes.tab, isActive && classes.active)}
        to={to}
        end={end}
        viewTransition
        draggable={false}
      >
        {content}
      </NavLink>
    );
  }

  return (
    <button
      type="button"
      className={c(classes.tab, activeProp && classes.active)}
      onClick={onClick}
    >
      {content}
    </button>
  );
};
